import request from '../request';
import querystring from 'querystring';

export default async function patchRequest(baseUrl, params = '', body) {
	if (params) params = `?${querystring.stringify(params)}`;
	let url = `${baseUrl}${params}`;
	let response = await request({
		method: 'patch',
		url,
		data: body,
	});
	return response;
}
